import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=03f92666"
import script from "./GroupModal.vue?vue&type=script&lang=ts"
export * from "./GroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f92666')) {
      api.createRecord('03f92666', component.options)
    } else {
      api.reload('03f92666', component.options)
    }
    module.hot.accept("./GroupModal.vue?vue&type=template&id=03f92666", function () {
      api.rerender('03f92666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/groups/GroupModal.vue"
export default component.exports